export const isInternalLink = (link) =>
  String(link?.kind || '').trim() === 'internal' && String(link?.href || '').startsWith('/');

export const isExternalLink = (link) => String(link?.kind || '').trim() === 'external';

export const isAnchorLink = (link) =>
  String(link?.kind || '').trim() === 'anchor' && String(link?.href || '').startsWith('#');

